import React from 'react';
import { useQuery } from '@apollo/client';
import { ProductQueryContextProvider } from '../hooks';
import { GET_CATEGORY_OPTIONS } from '../../graphql';
import { Category } from '../../../../server-types';
import Products from './ProductTable';

export const ProductTable = () => {
    const { loading, error, data } = useQuery<{ categories: Category[] }>(GET_CATEGORY_OPTIONS);
    if(loading && !data) {
        return null;
    }
    if(error){
        throw error;
    }

    return (
        <ProductQueryContextProvider>
            <Products />
        </ProductQueryContextProvider>
    );
};
